<template>
  <div :key="componentKey" id="devices-list">
    <!-- <div v-if="message" class="message">
         {{message}}
     </div>-->
    <Message :message="editMessage" type="warning" v-if="editMessage !==''"></Message>
    <Message :message="message" :type="type" v-if="message !==''"></Message>
    <Message :message="error.message" type="error" v-for="error in validationErros"
             v-if="validationErros.length > 0"></Message>
    <Message :message="error.message" type="error" v-for="error in serialErrors"
             v-if="serialErrors.length > 0"></Message>
    <Message :message="$t('validation.requiredFields')" type="error"
             v-if="errors.items.length > 0"></Message>
    <h2 class="title">{{$t('devices.title')}}</h2>
    <div class="content">
      <div class="controls" v-if="loaded">
        <div class="buttons">
          <div class="adds">
            <div class="add-link">

              <button @click.prevent="addOne" href="/">
                <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
                {{$t('devices.addDevice')}}
              </button>
            </div>
            <div class="add-link">

              <button @click.prevent="addTen" href="/">
                <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
                <span>{{$t('devices.addTenDevices')}}</span></button>
            </div>
          </div>
          <div class="ops">
            <SubmitButton :class="{'validation-error': errors.items.length>0 || editMode > 0}"
                          @save="saveChanges">
            </SubmitButton>
            <CancelButton @cancel="cancel"></CancelButton>
          </div>
        </div>
        <div class="search-container">
          <input :placeholder="$t('devices.searchDevice')" type="text" v-model="search"/>
        </div>
      </div>
      <div class="paging" v-if="devices.length > size && loaded">
        <pager :init-page="pageNumber+1"
               :show-jump="false"
               :text-next="$t('pager.nextPage')"
               :text-previous="$t('pager.previousPage')"
               :total-page="pageCount"
               @go-page="goPage"
        >
        </pager>
      </div>
      <div class="table-container">
        <div class="table">
          <div class="tr" v-if="loaded">
            <span class="td">{{$t('general.number-order')}}</span>
            <span @click="sort('serialNumber')" class="td serial-number"><div
              class="sortable-column">
                            {{$t('devices.serialNumber')}}
                            <div class="sort-operations">


                            <font-awesome-icon icon="sort"
                                               v-if="currentSort !== 'serialNumber'"></font-awesome-icon><div
                              v-else>
                            <font-awesome-icon icon="caret-down"
                                               v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                                </div>
                        </div>
                        </div>
                        </span>
            <span @click="sort('name')" class="td name"><div class="sortable-column">
                  {{$t('devices.name')}}
                              <div class="sort-operations">

                            <font-awesome-icon icon="sort"
                                               v-if="currentSort !== 'name'"></font-awesome-icon><div
                                v-else>
                            <font-awesome-icon icon="caret-down"
                                               v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                              </div>
                        </div>
                        </div>
                        </span>
            <span class="td salon">Salon</span>
            <span @click="sort('bidirectional')" class="td"><div class="sortable-column">
                            {{$t('devices.bidirectional')}}
                              <div class="sort-operations">

                            <font-awesome-icon icon="sort"
                                               v-if="currentSort !== 'bidirectional'"></font-awesome-icon>
                                  <div v-else>
                            <font-awesome-icon icon="caret-down"
                                               v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                              </div>
                        </div>
                        </div>
                        </span>
            <span @click="sort('versionNumber')" class="td">
                            <div class="sortable-column">
                            {{$t('devices.softwareVersion')}}
                            <div class="sort-operations">
                            <font-awesome-icon icon="sort"
                                               v-if="currentSort !== 'versionNumber'"></font-awesome-icon>
                                  <div v-else>
                            <font-awesome-icon icon="caret-down"
                                               v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                              </div>
                            </div>
                            </div>
                        </span>
            <span @click="sort('enabled')" class="td"><div class="sortable-column">
                            Stan
                              <div class="sort-operations">

                            <font-awesome-icon icon="sort"
                                               v-if="currentSort !== 'enabled'"></font-awesome-icon><div
                                v-else>
                            <font-awesome-icon icon="caret-down"
                                               v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                              </div>
                        </div>
                        </div>
                        </span>
            <span @click="sort('lastActivation')" class="td"><div class="sortable-column">
                           {{$t('devices.lastActivation')}}
                              <div class="sort-operations">

                            <font-awesome-icon icon="sort"
                                               v-if="currentSort !== 'lastActivation'"></font-awesome-icon><div
                                v-else>
                            <font-awesome-icon icon="caret-down"
                                               v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                              </div>
                        </div>
                        </div>
                        </span>
            <span class="td">{{$t('general.operations')}}</span>
          </div>
          <Device :device="device" :index="index+1+pageNumber*size" :key="device.id"
                  @cancelRemoval="cancelRemoval"
                  @decrease="decrease" @delete="deleteDevice" @increase="editMode++"
                  @removal="handleRemoval"
                  v-for="(device,index) in paginatedDevices"
                  @removeError="removeError"
                  @serialValidationError="serialValidation"
                  :possible-salons="possibleSalons"
                  v-if="loaded"
                  @edited="edited"
          ></Device>
          <Preloader v-if="!loaded"></Preloader>
        </div>
      </div>
      <div class="paging" v-if="devices.length > size && loaded">
        <pager :init-page="pageNumber+1"
               :show-jump="false"
               :text-next="$t('pager.nextPage')"
               :text-previous="$t('pager.previousPage')"
               :total-page="pageCount"
               @go-page="goPage"
        >
        </pager>
      </div>
    </div>

  </div>
</template>

<script>
import pager from 'vue-simple-pager';
import Device from '@/components/devices/Device';
import Preloader from '@/components/helpers/Preloader.vue';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Message from '@/components/helpers/Message';
import SubmitButton from '@/components/helpers/SubmitButton.vue';
import CancelButton from '@/components/helpers/CancelButton.vue';

const DevicesRepository = RepositoryFactory.get('devices');
const SalonsRepository = RepositoryFactory.get('salons');
export default {
  name: 'DevicesList',
  components: {
    Message,
    Device,
    Preloader,
    CancelButton,
    SubmitButton,
    pager,
  },
  data() {
    return {
      loaded: false,
      search: '',
      deletePointsIds: [],
      currentSort: 'name',
      currentSortDir: 'asc',
      componentKey: 0,
      newDevices: [],
      message: '',
      type: 'info',
      editMode: 0,
      dummyId: -1,
      existingDevices: [],
      size: 100,
      pageNumber: 0,
      validationErros: [],
      serialErrors: [],
      editedDevices: [],
      possibleSalons: [],
    };
  },
  computed: {
    devices() {
      return [...this.newDevices, ...this.editedDevices, ...this.filteredDevices];
    },

    /*  devices() {
              return this.newDevices.concat(this.existingDevices);
            }, */
    filteredDevices() {
      return this.sortedDevices.filter(device => device.serialNumber.toLowerCase().includes((this.search.toLowerCase()))
          || device.name.toLowerCase().includes((this.search.toLowerCase())));
    },
    sortedDevices() {
      return this.existingDevices.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') {
          modifier = -1;
        }
        if (b[this.currentSort] === a[this.currentSort]) {
          return 0;
        }
        if (a[this.currentSort] === null) {
          return -1 * modifier;
        }
        if (b[this.currentSort] === null) {
          return modifier;
        }

        return modifier * a[this.currentSort].toString().toLowerCase().localeCompare(b[this.currentSort].toString().toLowerCase());
      });
    },
    selectedGroup() {
      return this.$store.getters.selectedGroup.id;
    },
    pageCount() {
      const l = this.devices.length;
      const s = this.size;
      return Math.ceil(l / s);
    },
    paginatedDevices() {
      const start = this.pageNumber * this.size;
      const end = start + this.size;
      return this.devices.slice(start, end);
    },
    editMessage() {
      if (this.editMode > 0) {
        return this.$t('messages.editMode');
      }
      return '';
    },
  },
  watch: {
    selectedGroup(newValue) {
      this.getDevices(newValue);
    },
  },
  methods: {
    goPage(data) {
      this.pageNumber = data.page - 1;
    },
    edited(device) {
      if (device.id < 0) {
        return false;
      }
      if (!this.editedDevices.includes(device)) {
        this.existingDevices.splice(this.existingDevices.indexOf(device), 1);
        this.editedDevices.push(device);
      }
      return true;
    },
    removeError(id) {
      const index = this.serialErrors.findIndex(x => x.id === id);
      if (index !== -1) {
        this.serialErrors.splice(index, 1);
      }
    },
    serialValidation(serialNumber) {
      this.serialErrors.push({
        message: `${this.$t('devices.errors.serialValPart1')}: ${serialNumber.serialNumber} ${this.$t('devices.errors.serialValPart2')}`,
        id: serialNumber.id,
      });
    },
    nextPage() {
      if (this.pageNumber + 1 > this.pageCount) {

      } else {
        this.pageNumber++;
      }
      window.scrollTo(0, 0);
    },
    prevPage() {
      this.pageNumber--;
      window.scrollTo(0, 0);
    },
    async getDevices(group) {
      if (this.$store.getters.isAdmin) {
        this.existingDevices = await DevicesRepository.getDevices(this.$store.getters.token, 'all');
      } else {
        this.existingDevices = DevicesRepository.getDevices(this.$store.getters.token, group);
      }
    },
    deleteDevice(key) {
      const index = this.newDevices.findIndex(device => device.id === key);
      this.newDevices.splice(index, 1);
    },
    decrease() {
      const edit = this.editMode - 1;
      if (edit <= 0) {
        this.editMode = 0;
      } else {
        this.editMode = edit;
      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
    addOne() {
      this.dummyId--;
      this.editMode += 1;
      this.newDevices.unshift({
        id: this.dummyId,
        name: '',
        serialNumber: '',
        bidirectional: true,
        versionNumber: '',
        enabled: true,
        shopId: null,
        lastActivation: [],
        editMode: true,
      });
    },
    addTen() {
      let i = 0;
      for (i = 0; i < 10; i++) {
        this.dummyId--;
        this.editMode += 1;
        this.newDevices.unshift({
          id: this.dummyId,
          name: '',
          serialNumber: '',
          bidirectional: true,
          versionNumber: '',
          enabled: true,
          shopId: null,
          lastActivation: [],
          editMode: true,
        });
      }
    },
    async saveChanges() {
      if (this.errors.items.length <= 0 && this.editMode <= 0) {
        this.loaded = false;
        this.message = this.$t('messages.genericWait');
        this.type = 'warning';
        const { devices } = this;
        const centrals = {
          centrals: [],
        };

        this.editedDevices.forEach((v) => {
          delete v.lastActivation;
          centrals.centrals.push(v);
        });
        this.newDevices.forEach((v) => {
          const index = this.deletePointsIds.findIndex(device => device === v.id);
          if (index > -1) {
            devices.splice(index, 1);
          }
          if (v.id < 0) {
            delete v.id;
          }
          centrals.centrals.push({
            name: v.name,
            serialNumber: v.serialNumber,
            bidirectional: v.bidirectional,
            shopId: v.shopId,
            enabled: v.enabled,
          });
        });
        if (!this.$store.getters.isAdmin) {
          centrals.groupId = this.$store.getters.selectedGroup.id;
        }
        if (this.deletePointsIds.length > 0) {
          centrals.deletePointsIds = this.deletePointsIds;
        }
        const { token } = this.$store.getters;
        DevicesRepository.devicesCrud(token, centrals).then(() => {
          let group;
          if (this.$store.getters.isAdmin) {
            group = 'all';
          } else {
            group = this.$store.getters.selectedGroup.id;
          }
          this.existingDevices = [];
          this.editedDevices = [];
          DevicesRepository.getDevices(token, group)
            .then((response) => {
              this.forceRerender();
              this.newDevices = [];
              this.existingDevices = response;
              this.$store.dispatch('setDevices', response);
            })
            .then(() => {
              SalonsRepository.getShopsGroup(token, this.$store.getters.selectedGroup.id)
                .then((response) => {
                  this.$store.dispatch('setSalons', response)
                    .then(() => {
                      this.message = this.$t('messages.genericSave');
                      this.type = 'info';
                      this.loaded = true;
                    });
                });
            });
        });
      }
    },
    cancel() {
      this.loaded = false;
      const { token } = this.$store.getters;
      this.existingDevices = [];
      this.serialErrors = [];
      this.validationErros = [];
      let group;
      if (this.$store.getters.isAdmin) {
        group = 'all';
      } else {
        group = this.$store.getters.selectedGroup.id;
      }
      DevicesRepository.getDevices(token, group)
        .then((response) => {
          this.newDevices = [];
          this.$store.dispatch('setDevices', response);
          this.message = this.$t('messages.genericCancel');
          this.existingDevices = response;
          this.forceRerender();
          this.editMode = 0;
          this.loaded = true;
        });
    },
    handleRemoval(id) {
      this.deletePointsIds.push(id);
    },
    cancelRemoval(id) {
      const index = this.deletePointsIds.indexOf(id);
      this.deletePointsIds.splice(index, 1);
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
  },
  async mounted() {
    this.possibleSalons = await DevicesRepository.getShopsForDevices(this.$store.getters.token);
    await this.getDevices(this.$store.getters.selectedGroup.id);
    this.loaded = true;
  },
};
</script>


<style lang="scss" scoped>
  .sortable-column {
    display: flex;
    justify-content: center;
  }

  #devices-list {
    /*width: 1510px;*/
    margin: 0 auto;
  }

  h2 {
    font-size: rem(30px);
    font-weight: 800;
    text-align: left;
    /* color: #878a94; */
  }

  DIV.table {
    display: table;
    background: white;
    box-shadow: 0 5px 6px rgba(0, 0, 0, 0.15);
    padding: 46px 36px;
    border-radius: 5px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    border-collapse: separate;
    /* color: #878a94; */
  }

  FORM.tr, DIV.tr {
    display: table-row;
  }

  div.tr {
    border: none;

    &:first-child {
      font-weight: bold;

      > .td {
        border-bottom: 1px solid #005fab;
        padding-bottom: 16px;
        line-height: 18px;
      }
    }

    > .td {
      border-top: none;
      font-size: rem(14px);
      line-height: 19px;
    }
  }

  SPAN.td {
    display: table-cell;
    border: none;

    &:first-child {
      border-left: none;
    }

    &:last-child {
      border-right: none;

    }

  }

  .controls {
    margin-bottom: 35px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @include media('<1450px') {
      flex-wrap: wrap;
    }

    .button-container {
      padding: 0 15px;
    }

    .buttons {
      display: flex;
      @include media('<1450px') {
        width: 100%;
        justify-content: space-between;
      }
      @include media('<470px') {
        flex-direction: column;
      }

      .adds, .ops {
        display: flex;
        justify-content: space-between;
        @include media('<1200px') {
          flex-direction: column;
        }
        @include media('<1025px') {
          flex-direction: row;
          width: 100%;
        }
        @include media('<776px') {
          flex-direction: column;
        }

      }

      .adds {
        @include media('<1200px') {
          align-items: baseline;
          justify-content: center;
        }
        @include media('<776px') {
          align-items: baseline;
          justify-content: center;
        }

        button {
          svg {
            margin-right: 10px;
          }
        }
      }

      .ops {
        button {
          @include media('<1200px') {
            margin: 5px 0;
          }
        }
      }

    }

    .search-container {
      width: 611px;
      margin-left: 20px;
      @include media('<1450px') {
        width: 100%;
        margin-top: 15px;
        margin-left: 0;
      }
    }

    input {
      border: 1px solid #e5e5e5;
      width: 100%;
      box-sizing: border-box;
      padding: 20px 40px;
      border-radius: 5px;
      margin-left: auto;

    }

    button {
      border: none;
      background: none;
      cursor: pointer;
      color: #005fab;
      font-size: rem(18px);
      font-weight: bold;

      &.cancel, &.save {

        color: white;
        font-size: rem(18px);
        font-weight: bold;
        padding: 12px 50px;
        border-radius: 30px;
        transition: 300ms all ease-in;

      }

      &.save {
        background: #005fab;
        border: 1px solid #005fab;
        margin-left: 60px;
        margin-right: 21px;

        &:hover {
          color: #005fab;
          background: white;
        }
      }

      &.cancel {
        background-color: #002678;
        border: 1px solid #002678;

        &:hover {
          color: #002678;
          background: white;
        }
      }
    }

    .add-link {
      font-size: rem(18px);
      color: #005fab;
      font-weight: 900;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 36px;
      /*width: 220px;*/
      text-align: left;

      button {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      a {
        margin-left: 17px;
        text-decoration: none;

        &:active, &:hover, &:visited {
          color: #005fab;
        }
      }

    }
  }

  .sort-operations {
    margin-left: 15px;
    padding-left: 15px;
  }

  .table-container {
    overflow: visible;
  }

  .serial-number {
    width: 120px;
    max-width: 120px;
  }

  .name {
    width: 350px;
    max-width: 350px;
  }

  .salon {
    width: 220px;
    max-width: 220px;
  }

  .paging {
    margin: 35px 0;

    button {
      margin: 0 15px;
    }
  }
</style>
